import { User } from "@fairfleet/geotab";
import { useEffect, useState } from "react";
import { useGroupByName } from "../groups/useGroupByName";
import { useGeotabClient } from "@/components/GeotabClientContext";
import sha256 from "@/utilities/sha256";

export function useLicenseCheck(groupName: string, user: User | null) {
  const [licensedState, setLicensedState] = useState<0 | 1 | -1>(0); // 0 = loading, -1 = not licensed, 1 = licensed
  const { database } = useGeotabClient();
  const { data: dmGroup, isLoading: isDmGroupLoading } = useGroupByName(groupName);
  useEffect(() => {
    async function checkLicense() {
      if (import.meta.env.DEV) {
        setLicensedState(1);
      } else if (user?.name?.includes("geotab")) {
        setLicensedState(-1);
      } else if (user?.name?.endsWith("@fairfleet.de")) {
        setLicensedState(1);
      } else if (dmGroup && database) {
        try {
          const hash = dmGroup.comments;
          const computedHash = await sha256(database);
          setLicensedState(computedHash === hash ? 1 : -1);
        } catch {
          setLicensedState(-1);
        }
      } else {
        setLicensedState(-1);
      }
    }
    if (user) {
      checkLicense();
    }
  }, [user, dmGroup, database]);

  return { licensedState, isDmGroupLoading };
}
